module.exports = __webpack_public_path__ + "static/media/26-11.b282f64a.mp3";